<template>
  <div class="container">
    <p class="title">Wie alt ist Josephine gerade?</p>
    <p><strong><ICountUp :endVal="years" :options="countUpOptions" /></strong> Jahre</p>
    <p><strong><ICountUp :endVal="months" :options="countUpOptions" /></strong> Monate</p>
    <p><strong><ICountUp :endVal="weeks" :options="countUpOptions" /></strong> Wochen</p>
    <p><strong><ICountUp :endVal="days" :options="countUpOptions" /></strong> Tage</p>
    <p><strong><ICountUp :endVal="hours" :options="countUpOptions" /></strong> Stunden</p>
    <p><strong><ICountUp :endVal="minutes" :options="countUpOptions" /></strong> Minuten</p>
  </div>
</template>

<script>
import ICountUp from "vue-countup-v2";
import moment from "moment";

export default {
  name: "Alter",
  components: {
    ICountUp
  },
  data() {
    return {
      birthday: moment(1558975560000),
      now: moment(),
      countUpOptions: {
        separator:"."
      }
    };
  },
  computed: {
    minutes: function() {
      return this.now.diff(this.birthday, "minutes");
    },
    hours: function() {
      return this.now.diff(this.birthday, "hours");
    },
    days: function() {
      return this.now.diff(this.birthday, "days");
    },
    weeks: function() {     
      return this.now.diff(this.birthday, "weeks");
    },
    months: function() {
      return this.now.diff(this.birthday, "months");
    },
    years: function() {
      return this.now.diff(this.birthday, "years");
    }
  }
};
</script>